// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.check-video[data-v-c7daa442] {\n  width: 100%;\n  font-size: 12px;\n  text-align: left;\n}\n.check-video__title[data-v-c7daa442] {\n  margin-bottom: 10px;\n  color: #000;\n  font-size: 12px;\n}\n.check-video__test[data-v-c7daa442] {\n  margin-top: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
